import {
  Button,
  List,
  ListItem,
  Popover,
  TableCell,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditSurveyCategory from "./EditSurveyCategory";
import DeleteSurveyCategory from "./DeleteSurveyCategory";
import EditSurveyQuestion from "./EditSurveyQuestion";
import DeleteSurveyQuestion from "./DeleteSurveyQuestion";
import useAuthToken from "../../hooks/getUserData";

export default function AiSurveyListContent({
  row,
  columns,
  index,
  tableName,
  fetchData,
  setMessage,
  setSnackbarOpen,
  categories, 
}) {
  const { id } = row;
  const token = useAuthToken();
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <TableRow hover key={id}>
      {columns.map((column) => {
        const { id: columnId } = column;
        let cellContent;

        if (columnId === "sno") {
          cellContent = index + 1;
        } else if (columnId === "actions") {
          cellContent = (
            <div>
              <Button onClick={handleMenuOpen}>
                <MoreVertIcon /> 
              </Button>
              <Popover
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <List>
                  {tableName === "Category" ? (
                    <>
                      <ListItem>
                        <EditSurveyCategory
                          category={row}
                          fetchData={fetchData}
                          setMessage={setMessage}
                          setSnackbarOpen={setSnackbarOpen}
                          token={token}
                        />
                      </ListItem>
                      <ListItem>
                        <DeleteSurveyCategory
                          category={row}
                          fetchData={fetchData}
                          token={token}
                          setMessage={setMessage}
                          setSnackbarOpen={setSnackbarOpen}
                        />
                      </ListItem>
                    </>
                  ) : (
                    <>
                      <ListItem>
                        <EditSurveyQuestion
                          question={row}
                          fetchData={fetchData}
                          setMessage={setMessage}
                          setSnackbarOpen={setSnackbarOpen}
                          token={token}
                          categories={categories} 
                        />
                      </ListItem>
                      <ListItem>
                        <DeleteSurveyQuestion
                          question={row}
                          fetchData={fetchData}
                          token={token}
                          setMessage={setMessage}
                          setSnackbarOpen={setSnackbarOpen}
                        />
                      </ListItem>
                    </>
                  )}
                </List>
              </Popover>
            </div>
          );
        } else {
          cellContent = row[columnId] || "-";
        }

        return (
          <TableCell
            key={columnId}
            align="center"
            sx={
              columnId === "actions"
                ? {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : {}
            }
          >
            {cellContent}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
